// Enum baseado no DTO fornecido
export enum ReservationRoomStatus {
  PENDING = 'pending',         // criada mas não confirmada ainda
  CONFIRMED = 'confirmed',     // validada, quarto está bloqueado
  IN_PROGRESS = 'in_progress', // hóspede fez check-in
  COMPLETED = 'completed',     // hóspede fez check-out
  CANCELLED = 'cancelled',     // reserva cancelada
  NO_SHOW = 'no_show',         // hóspede nunca apareceu

}

export type HotelReservationType = {
  id: number
  pluginspaceId: number
  roomId: number
  customerId: number
  checkIn: Date
  checkOut?: Date
  status: ReservationRoomStatus
  // Campos adicionais que podem vir da API
  roomNumber?: string
  customerName?: string
  customerEmail?: string
  customerPhone?: string
  roomType?: string
  totalPrice?: number
  createdAt?: Date
  updatedAt?: Date
}

export type CreateHotelReservationDto = {
  roomId: number
  customerId: number
  checkIn: Date
  checkOut?: Date
  status?: ReservationRoomStatus
}

// Funções utilitárias para labels
export const getReservationStatusLabel = (status: ReservationRoomStatus): string => {
  const statusLabels = {
    [ReservationRoomStatus.PENDING]: 'Pendente',
    [ReservationRoomStatus.CONFIRMED]: 'Confirmada',
    [ReservationRoomStatus.IN_PROGRESS]: 'Em Andamento',
    [ReservationRoomStatus.COMPLETED]: 'Finalizado',
    [ReservationRoomStatus.CANCELLED]: 'Cancelada',
    [ReservationRoomStatus.NO_SHOW]: 'Não Compareceu',
   
  }
  return statusLabels[status] || status
}

export const getReservationStatusColor = (status: ReservationRoomStatus): string => {
  const colors = {
    [ReservationRoomStatus.PENDING]: 'warning',
    [ReservationRoomStatus.CONFIRMED]: 'info',
    [ReservationRoomStatus.IN_PROGRESS]: 'primary',
    [ReservationRoomStatus.COMPLETED]: 'success',
    [ReservationRoomStatus.CANCELLED]: 'danger',
    [ReservationRoomStatus.NO_SHOW]: 'secondary',
  }
  return colors[status] || 'secondary'
}

export const formatDate = (date: Date | string): string => {
  if (!date) return ''
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateObj.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const formatDateForInput = (date: Date | string): string => {
  if (!date) return ''
  const dateObj = typeof date === 'string' ? new Date(date) : date
  const year = dateObj.getFullYear()
  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const day = String(dateObj.getDate()).padStart(2, '0')
  const hours = String(dateObj.getHours()).padStart(2, '0')
  const minutes = String(dateObj.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:${minutes}`
}
